<template>
  <section v-if="$role.restricAccess($route.name, 'view')">
    
    <breadcrumb-template
      :headtitle="$route.meta.title"
      :breadcrumbcurrent="$route.meta.title"
    ></breadcrumb-template>

    <!-- <v-card class="card-outline">
            <v-card-text> -->
    <v-container fluid>
      <v-row dense class="d-flex justify-left mt-n2 dashboard-icons">

        <v-col cols="12" class="mt-5 mb-5">
          <h5>Congratulations to our daily winners!</h5>
          <v-simple-table class="custom-header-color table-bordered table-striped">
            <template v-slot:default>
              <thead>
                <tr>
                  <th>Draw</th>
                  <th>Player</th>
                  <th>Payout</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in dashboard_totdailywinners" :key="index">
                  <td>{{ item.name }}</td>
                  <td>{{ item.username }}</td>
                  <td>
                    <v-avatar :size="$gold_coin_sm"><img :src="$goldCoinWhite" alt="coin" /></v-avatar> {{ item.payout | toNumberWithDecimal}}</td>
                  <td>
                    <v-badge v-if="item.claimed == 'Unclaimed'" color="red_button" content="Unclaimed" inline></v-badge>
                    <v-badge v-else color="green" content="Claimed" inline></v-badge>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
        <!-- <v-col cols="12" lg="4">
          <v-card class="mx-auto" :color="$vuetify.theme.themes['dark'].dashboard_boxes" dark elevation="5" loading>
            <v-card-title>
              <v-row>
                <v-col cols="8">
                  <v-row no-gutters>
                    <v-col cols="12">
                      {{ agent_parent }} / {{ $levelNames(agent_level - 1) }}
                    </v-col>
                    <v-col cols="12">
                      <span class="text-h7 font-weight-light">Parent / Level</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <span class="d-flex justify-center"><v-icon class="" size="70">mdi-account</v-icon></span>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col> -->

        <v-col cols="12" lg="4" v-if="$store.state.currentUser.agent_data.level == 0">
          <v-card class="mx-auto" :color="$vuetify.theme.themes['dark'].dashboard_boxes" dark elevation="5" loading>
            <v-card-title>
              <v-row class="d-flex justify-center">
                <v-col cols="8">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-avatar :size="$gold_coin_lg"
                        ><img :src="$goldCoinPile" alt="coin"
                      /></v-avatar>
                      <span class="ml-2">{{
                        balance | toNumberWithDecimal
                      }}</span>
                    </v-col>
                    <v-col cols="12">
                      <span class="text-h7 font-weight-light"
                        >Gems balance</span
                      >
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="2">
                  <!-- <span class="d-flex justify-center"><v-icon class="" size="70">mdi-alpha-c-circle-outline</v-icon></span> -->
                  <span class="d-flex justify-center"
                    ><v-avatar size="70"
                      ><img
                        src="images/mrm_logos/Gem-300x300.png"
                        alt="coin"/></v-avatar
                  ></span>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>

        <!-- <v-col
          cols="12"
          lg="4"
          v-if="$store.state.currentUser.agent_data.level <= 1"
        >
          <v-card
            class="mx-auto"
            :color="$vuetify.theme.themes['dark'].dashboard_boxes"
            dark
            elevation="5"
            loading
          >
            <v-card-title>
              <v-row>
                <v-col cols="8">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-avatar :size="$gold_coin_lg"
                        ><img src="images/mrm_logos/Player-Manager-Gold-25x25.png" alt="coin"
                      /></v-avatar>
                      <span class="ml-2">{{ count_managers }}</span>
                    </v-col>
                    <v-col cols="12">
                      <span class="text-h7 font-weight-light"><span>{{ $agentName }}</span></span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <span class="d-flex justify-center"
                    ><v-icon class="" size="70">mdi-account</v-icon></span
                  >
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col> -->

        <!-- <v-col cols="12" lg="4">
          <v-card
            class="mx-auto"
            :color="$vuetify.theme.themes['dark'].dashboard_boxes"
            dark
            elevation="5"
            loading
          >
            <v-card-title>
              <v-row>
                <v-col cols="8">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-avatar :size="$gold_coin_lg"
                        ><img src="images/mrm_logos/Player-Manager-Gold-25x25.png" alt="coin"
                      /></v-avatar>
                      <span class="ml-2">{{ total_player }}</span>
                    </v-col>
                    <v-col cols="12">
                      <span class="text-h7 font-weight-light">All players</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <span class="d-flex justify-center"
                    ><v-icon class="" size="70">mdi-account</v-icon></span
                  >
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col> -->

        <v-col cols="12" lg="4">
          <v-card
            class="mx-auto"
            :color="$vuetify.theme.themes['dark'].dashboard_boxes"
            dark
            elevation="5"
            loading
          >
            <v-card-title>
              <v-row class="d-flex justify-center">
                <v-col cols="8">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-avatar :size="$gold_coin_lg"
                        ><img :src="$goldCoinPile" alt="coin"
                      /></v-avatar>
                      <span class="ml-2">{{
                        setsettings != 1
                          ? "TBP"
                          : daily_sales | toNumberWithDecimal
                      }}</span>
                    </v-col>
                    <v-col cols="12">
                      <span class="text-h7 font-weight-light"
                        >Daily gross sales</span
                      >
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="2">
                  <span class="d-flex justify-center"
                    ><v-icon class="" size="70"
                      >mdi-chart-line-stacked</v-icon
                    ></span
                  >
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>

        <v-col cols="12" lg="4">
          <v-card
            class="mx-auto"
            :color="$vuetify.theme.themes['dark'].dashboard_boxes"
            dark
            elevation="5"
            loading
          >
            <v-card-title>
              <v-row class="d-flex justify-center">
                <v-col cols="8">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-avatar :size="$gold_coin_lg"
                        ><img :src="$goldCoinPile" alt="coin"
                      /></v-avatar>
                      <span class="ml-2">{{
                        setsettings != 1
                          ? "TBP"
                          : commissions | toNumberWithDecimal
                      }}</span>
                    </v-col>
                    <v-col cols="12">
                      <span class="text-h7 font-weight-light"
                        >Daily commissions</span
                      >
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="2">
                  <span class="d-flex justify-center"
                    ><v-icon class="" size="70">mdi-sale</v-icon></span
                  >
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>

        <v-col cols="12" lg="4">
          <v-card
            class="mx-auto"
            :color="$vuetify.theme.themes['dark'].dashboard_boxes"
            dark
            elevation="5"
            loading
          >
            <v-card-title>
              <v-row class="d-flex justify-center">
                <v-col cols="8">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-avatar :size="$gold_coin_lg"
                        ><img :src="$goldCoinPile" alt="coin"
                      /></v-avatar>
                      <span class="ml-2">{{ dailywinnings | toNumberWithDecimal }}</span>
                    </v-col>
                    <v-col cols="12">
                      <span class="text-h7 font-weight-light"
                        >Daily payouts</span
                      >
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="2">
                  <!-- <span class="d-flex justify-center"><v-icon class="" size="70">mdi-account</v-icon></span> -->
                  <span class="d-flex justify-center"
                    ><v-avatar size="70"
                      ><img
                        src="images/mrm_logos/Prize-300x300.png"
                        alt="coin"/></v-avatar
                  ></span>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" lg="4" @click="goto('online_players')" style="cursor: pointer;">
          <v-card
            class="mx-auto"
            :color="$vuetify.theme.themes['dark'].dashboard_boxes"
            dark
            elevation="5"
            loading
          >
            <v-card-title>
              <v-row>
                <v-col cols="8">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-avatar :size="$gold_coin_lg"
                        ><img src="images/gold-avatar.png" alt="coin"
                      /></v-avatar>
                      <span class="ml-2">{{ total_active_players }}</span>
                    </v-col>
                    <v-col cols="12">
                      <span class="text-h7 font-weight-light" :to="{ name: 'online_players' }">Online players</span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <span class="d-flex justify-center"
                    ><v-icon class="" size="70">mdi-account</v-icon></span
                  >
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col> -->

        <!-- <v-col cols="12" lg="4" v-if="$store.state.currentUser.agent_data.level == 0 || $store.state.currentUser.agent_data.level == 1">
          <v-card class="mx-auto" :color="$vuetify.theme.themes['dark'].dashboard_boxes" dark elevation="5" loading>
            <v-card-title>
              <v-row>
                <v-col cols="8">
                  <v-row no-gutters>
                    <v-col cols="12">
                      <v-avatar :size="$gold_coin_lg"
                        ><img src="images/mrm_logos/Player-Manager-Gold-25x25.png" alt="coin"
                      /></v-avatar>
                      <span class="ml-2">{{ total_active_managers }}</span>
                    </v-col>
                    <v-col cols="12">
                      <span class="text-h7 font-weight-light">Online {{ $agentName }} </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="4">
                  <span class="d-flex justify-center"><v-icon class="" size="70">mdi-account</v-icon></span>
                </v-col>
              </v-row>
            </v-card-title>
          </v-card>
        </v-col> -->

      </v-row>
    </v-container>
    <!-- </v-card-text>
        </v-card> -->

    <!-- <section>
            <v-dialog v-model="disclaimerDialog" width="650px" scrollable persistent>
                <v-card class="card-outline custom-color-dialog">
                    <v-card-title class="headline headline_bg">
                        <span>Alert</span>
                    </v-card-title>

                    <v-card-text>
                        <v-row class="mt-3">
                            <v-col cols="12">
                                <span v-html="disclaimer"></span>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions class="actionButtons pt-6">
                        <v-row no-gutters>
                            <v-col cols="6" lg="6" class="px-2">
                                <v-btn color="custom_info" @click="disclaimerDialog = false">Close</v-btn>
                            </v-col>
                        </v-row>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </section> -->
  </section>
</template>

<script>
export default {
  data() {
    return {
      disclaimerDialog: false,
      total_player: null,
      daily_sales: null,
      commissions: null,
      dailywinnings: null,
      balance: null,
      agent_parent: null,
      agent_level: null,
      disclaimer: null,
      setsettings: null,
      count_managers: 0,
      total_active_players: 0,
      total_active_managers: 0,
      dashboard_totdailywinners:[],
    };
  },
  computed: {},
  methods: {
    goto(data){
        if(data){
            this.$router.push({ name: data });
        }
    },
    currentUserCallBelow() {
      if (this.$store.state.currentUser.agent_data.level == 0) {
        return "manager";
      } else if (this.$store.state.currentUser.agent_data.level == 1) {
        return "supervisor";
      } else {
        return "manager";
      }
    },
    async disclaimerAlert() {
      if (!this.$store.state.disclaimerAlert) {
        await this.getDisclaimer();
        this.disclaimerDialog = true;
        this.$store.commit("isDisclaimerAlert");
      }
    },
    getData() {
      this.$Fire.$emit("overlay", true);
      this.$axios
        .get(this.$_CONFIG.api("API_DASHBOARD"))
        .then((data) => {
          this.total_player = data.data.total_player;
          this.daily_sales = data.data.daily_sales;
          this.commissions = data.data.commissions;
          this.dailywinnings = data.data.dailywinnings;
          // this.total_active_managers = data.data.total_active_managers;
          // this.total_active_players = data.data.total_active_players;
          // this.balance = data.data.balance;
          this.agent_parent = data.data.level[0].parent;
          this.agent_level = data.data.level[0].level;
          this.$Fire.$emit("overlay", false);
        })
        .catch((err) => {
          this.formerror = err.response.data.errors;
        });
    },
    getDisclaimer() {
      this.$axios
        .get(this.$_CONFIG.api("API_DISCLAIMER"))
        .then((data) => {
          this.disclaimer = data.data;
        })
        .catch((err) => {
          this.formerror = err.response.data.errors;
        });
    },
    countManagers() {
      this.$axios
        .get(this.$_CONFIG.api() + "/dashboard_countmanagers")
        .then((data) => {
          this.count_managers = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    operatorBalance() {
      this.$axios
        .get(this.$_CONFIG.api() + "/dashboard_operatorBalance")
        .then((data) => {
          this.balance = data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getSettings() {
      this.$axios
        .get(this.$_CONFIG.api("API_SETTINGS"))
        .then((data) => {
          this.setsettings = data.data["publish"];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dashboard_onlineusers() {
      this.$axios
        .get(this.$_CONFIG.api() + "/dashboard_onlineusers")
        .then((data) => {
          this.total_active_players = data.data.onlinePlayers;
          this.total_active_managers = data.data.onlineGM;
          // console.log(data.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dashboard_dailywinners() {
      this.$axios
        .get(this.$_CONFIG.api() + "/dashboard_dailywinners")
        .then((data) => {
          this.dashboard_totdailywinners = data.data
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  async created() {
    await this.getData();
    await this.countManagers();
    await this.operatorBalance();
    // this.disclaimerAlert();
    await this.getSettings();
    await this.dashboard_onlineusers();
    await this.dashboard_dailywinners();

    // var channel = window.pusher.subscribe("winnerData");
    // channel.bind("App\\Events\\Winners", function(data) {
    //   console.log(data);
    // });
  },
  mounted() {},
};
</script>
<style scoped>
  .v-sheet.v-card {
      border-radius: 40px;
  }
</style>